/* FireFly model finder (2026-10-13).
   full mode: type a model number -> links to the liner(s) cut for it.
   product mode: filters this product's model buttons, links to another liner when the model lives there, and keeps
   Add to cart / Buy now locked until the shopper has picked a model (the theme always pre-selects the first one). */
(() => {
  const norm = (s) => String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const KIND = { Range: 'gas range liner', Cooktop: 'gas cooktop liner', Electric: 'electric stove top cover' };
  let idx = null, loading = null;
  const load = (url) => idx ? Promise.resolve(idx) : (loading = loading || fetch(url).then((r) => r.json()).then((j) => (idx = j)));
  function search(q) {
    const n = norm(q);
    if (n.length < 3) return { type: 'short', rows: [] };
    let rows = idx.filter((r) => r.n === n);
    if (rows.length) return { type: 'exact', rows };
    rows = idx.filter((r) => r.n.startsWith(n));
    if (rows.length) return { type: 'prefix', rows };
    for (let L = n.length - 1; L >= 6; L--) {
      const p = n.slice(0, L); rows = idx.filter((r) => r.n.startsWith(p));
      if (rows.length) return { type: 'close', rows };
    }
    return { type: 'none', rows: [] };
  }
  function el(tag, cls, text) { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function render(box, res, here) {
    box.replaceChildren();
    if (res.type === 'short') return;
    if (res.type === 'none') {
      const p = el('p', 'ff-finder__msg ff-finder__msg--warn', 'We have no liner listed for that model yet. ');
      const a = el('a', null, 'Send us your model number'); a.href = '/pages/contact'; p.append(a, document.createTextNode(' and we will check whether one of our cuts fits.'));
      box.append(p); return;
    }
    if (res.type === 'close') box.append(el('p', 'ff-finder__msg ff-finder__msg--warn', 'No exact match. These models are close: only order if the full model number matches the label on your stove.'));
    const groups = new Map();
    for (const r of res.rows) { const k = r.m + '|' + r.b + '|' + r.k; if (!groups.has(k)) groups.set(k, []); groups.get(k).push(r); }
    const ul = el('ul');
    [...groups.values()].slice(0, 12).forEach((rs) => {
      const li = el('li'); const nm = el('strong', null, rs[0].m); if (rs[0].p) { const pa = el('a', null); pa.href = rs[0].p; pa.append(nm); li.append(pa); } else li.append(nm); li.append(el('span', null, `${rs[0].b} ${KIND[rs[0].k] || ''}`));
      rs.forEach((r) => { const a = el('a', null, r.c); a.href = r.u; if (here && r.u.startsWith('/products/' + here + '?')) a.dataset.here = '1'; li.append(a); });
      ul.append(li);
    });
    box.append(ul);
    if (groups.size > 12) box.append(el('p', 'ff-finder__msg', `${groups.size - 12} more models start with that. Type more of the model number.`));
  }
  function initProduct(root) {
    const info = root.closest('.product-info') || document;
    const picker = info.querySelector('variant-picker');
    if (!picker) return;
    const form = document.getElementById(picker.getAttribute('form'));
    // the theme renders models either as buttons in a dropdown (popover listbox) or as radio + label swatches
    const items = [...picker.querySelectorAll('[data-option-value]')];
    const valOf = (it) => it.getAttribute('value') || it.textContent.trim();
    const pick = (it) => it.click();
    const legend = picker.querySelector('legend'); if (legend && /size/i.test(legend.textContent)) legend.textContent = 'Model number:';
    const gate = root.querySelector('[data-ff-gate]');
    let chosen = root.dataset.hasVariant === '1' || items.length <= 1;
    const shown = [picker.querySelector('variant-option-value'), picker.querySelector('[id$="-selected-value"]')].filter(Boolean);
    const setChosen = () => { if (chosen) return; chosen = true; picker.classList.remove('ff-unchosen'); if (gate) gate.hidden = true; };
    if (!chosen) { picker.classList.add('ff-unchosen'); shown.forEach((e) => { e.textContent = 'Select your model'; }); }
    picker.addEventListener('change', setChosen);
    picker.addEventListener('click', (e) => { if (e.target.closest('[data-option-value]')) setChosen(); });
    const block = (e) => {
      if (chosen) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (gate) gate.hidden = false;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    if (form) form.addEventListener('submit', block, true);
    document.addEventListener('click', (e) => {
      if (chosen) return;
      const b = e.target.closest('button[type="submit"], .shopify-payment-button, .shopify-payment-button__button');
      if (b && (b.form === form || (b.closest && b.closest('.product-info__buy-buttons')))) block(e);
    }, true);
    // gallery: show the general photos + ONLY the selected model's cut (each cut image is attached to its models' variants)
    const vm = {}; (root.dataset.vm || '').split(',').forEach((p) => { const [v, m] = p.split(':'); if (v && m) vm[v] = m; });
    const cutIds = new Set(Object.values(vm));
    const gallery = document.querySelector('product-gallery');
    const idInput = form && form.querySelector('input[name="id"]');
    let shownFor;
    const filterGallery = () => {
      if (!gallery || !cutIds.size || !idInput) return;
      const sel = chosen ? idInput.value : null; if (sel === shownFor) return; shownFor = sel;
      const keep = sel ? vm[sel] : null;
      const slides = [...gallery.querySelectorAll('.product-gallery__media[data-media-id]')];
      const thumbs = [...gallery.querySelectorAll('.product-gallery__thumbnail')];
      slides.forEach((sl, i) => {
        const id = sl.dataset.mediaId; const show = !cutIds.has(id) || id === keep;
        sl.classList.toggle('ff-media-hidden', !show); if (thumbs[i]) thumbs[i].classList.toggle('ff-media-hidden', !show);
      });
      const list = gallery.querySelector('.product-gallery__media-list');
      const target = keep && slides.find((sl) => sl.dataset.mediaId === keep);
      if (list) { if (target) list.scrollTo({ left: target.offsetLeft - list.offsetLeft, behavior: 'smooth' }); else list.scrollTo({ left: 0 }); }
    };
    filterGallery(); setInterval(filterGallery, 400);
    const input = root.querySelector('.ff-finder__input'), box = root.querySelector('[data-ff-results]');
    input.addEventListener('input', () => {
      const n = norm(input.value);
      let local = [];
      items.forEach((it) => {
        const v = norm(valOf(it)); const hit = n.length >= 2 && v.includes(n);
        it.classList.toggle('ff-swatch-hidden', n.length >= 2 && !hit); it.classList.toggle('ff-swatch-match', hit && v === n);
        if (hit) local.push(it);
      });
      const exact = items.find((it) => norm(valOf(it)) === n);
      if (exact && n.length >= 4) { pick(exact); setChosen(); box.replaceChildren(el('p', 'ff-finder__msg', `${valOf(exact)} is on this liner and is now selected.`)); return; }
      if (n.length < 3 || local.length) { box.replaceChildren(); if (local.length && n.length >= 3) box.append(el('p', 'ff-finder__msg', `${local.length} matching model${local.length > 1 ? 's' : ''} on this liner: ${local.slice(0, 6).map(valOf).join(', ')}${local.length > 6 ? '…' : ''}. Pick yours in the model list below.`)); return; }
      load(root.dataset.index).then(() => {
        const res = search(input.value);
        render(box, res, root.dataset.handle);
        if (res.type === 'exact' || res.type === 'prefix') box.prepend(el('p', 'ff-finder__msg', 'That model uses a different liner:'));
      });
    });
  }
  function initFull(root) {
    const input = root.querySelector('.ff-finder__input'), box = root.querySelector('[data-ff-results]');
    let t;
    input.addEventListener('focus', () => load(root.dataset.index), { once: true });
    input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => load(root.dataset.index).then(() => render(box, search(input.value))), 120); });
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); const a = box.querySelector('a'); if (a && box.querySelectorAll('li').length === 1) location.href = a.href; } });
  }
  function collapseCompat() { document.querySelectorAll('.product-info details[open], .prose details[open]').forEach((d) => { const s = d.querySelector('summary'); if (s && /compatib/i.test(s.textContent)) d.open = false; }); }
  function init() { collapseCompat(); document.querySelectorAll('[data-ff-finder]:not([data-ff-ready])').forEach((root) => { root.dataset.ffReady = '1'; (root.dataset.mode === 'product' ? initProduct : initFull)(root); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
